// removed by extract-text-webpack-plugin
module.exports = {"btn-wrapper":"Button_btn-wrapper---sb","btnWrapper":"Button_btn-wrapper---sb","ie-is-shit":"Button_ie-is-shit---sb","ieIsShit":"Button_ie-is-shit---sb","btn":"Button_btn---sb","prev":"Button_prev---sb","next":"Button_next---sb","rtl":"Button_rtl---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/Button/styles.less
// module id = 1523
// module chunks = 0